<template>
    <div class="page-wrapper">
        <section data-section-type="HeroBanner" data-section-variant="default" data-section-theme="black">
            <article class="relative w-full h-[160px]">
                <!-- Insert Image Here -->
                <div class="container mx-auto px-6 py-6 xl:py-8 xl:px-4 flex flex-col items-start justify-center absolute inset-0 z-20 text-shadow">
                    <h1>My Account</h1>
                    <h2 class="h4">More account features coming soon!</h2>
                </div>
            </article>
        </section>

        <section class="container mx-auto px-4 grid divide-y lg:grid-cols-12 lg:divide-y-0 lg:divide-x gap-2">
            <aside class="py-6 lg:col-span-3">
                <Menu v-on:menuClick="showPage" :page="currentPage"></Menu>
            </aside>
            <Profile v-if="currentPage === 'profile'" :user="user" v-on:updated="updateUser" :key="profileKey"></Profile>
            <OrderHistory v-if="currentPage === 'orderHistory'"></OrderHistory>
            <SaleBanner v-if="currentPage === 'saleBanner' && isSystemAdmin()"></SaleBanner>
        </section>
    </div>
</template>

<script>
    import Menu from './profile/AccountMenu'
    import Profile from './profile/Profile'
    import OrderHistory from './profile/OrderHistory'
    import SaleBanner from './profile/SaleBanner'

    export default {
        data() {
            return {
                user: this.$auth.user().details,
                currentPage: this.$route.hash !== '' ? this.$route.hash.replace('#', '') : 'profile',
                profileKey: 0
            }
        },

        components: {
            Menu,
            Profile,
            OrderHistory,
            SaleBanner,
        },

        mounted() {
            document.querySelector('header').classList.add('solid')
            window.events.$emit('finishedLoading')
        },

        destroyed() {
            document.querySelector('header').classList.remove('solid')
        },

        methods: {
            showPage(pageName) {
                this.currentPage = pageName
            },

            updateUser(data) {
                this.$auth.user().details = data
                this.user = data
                this.profileKey++
            },

            isSystemAdmin() {
                return this.$auth.user().roles.includes('System Admin')
            }
        }
    }
</script>
